import { LiveHome } from './LiveHome';

export default LiveHome;
